'use client';
import * as e from 'react';
import { TableHeadContext } from './table.context.js';
import { createComponent } from '../core/create-component.js';

const TableHead = createComponent({
    displayName: 'TableHead',
    root: 'thead',
    propConfig: {
        classNames: [
            'swan-thead'
        ],
        wrapRoot: (o, t, r)=>e.createElement(TableHeadContext.Provider, {
                value: !0
            }, r)
    }
});

export { TableHead };
